import type { FC, NamedExoticComponent, PropsWithChildren, ReactElement } from 'react'
import { memo } from 'react'

interface IEitherProps {
  condition: boolean | (() => boolean)
  fallback?: ReactElement | null
}

const Either: FC<IEitherProps> = ({ condition, children, fallback = <></> }) => {
  let result = true

  if (typeof condition === 'function') {
    result = condition()
  } else if (typeof condition === 'boolean') {
    result = condition
  }

  if (result) return children as ReactElement
  return fallback
}

export default memo(Either) as NamedExoticComponent<PropsWithChildren<IEitherProps>>
